export const TOKEN_NAME = "dpjTkn";